import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export interface PaymentsState {
  aggregation_level: string;
  seller_id: string;
  no_of_records: number;
  start_date: any;
  end_date: any;
  lookup: boolean;
  view: number;
}

export const initialState: PaymentsState = {
  aggregation_level: "asin",
  seller_id: "",
  no_of_records: parseInt("5", 10),
  start_date: null,
  end_date: null,
  lookup: false,
  view: 1,
};

export const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    changePaymentsState: (
      state: PaymentsState,
      action: PayloadAction<PaymentsState>
    ) => {
      state.aggregation_level = action.payload.aggregation_level;
      state.start_date = dayjs(action.payload.start_date).format("YYYY-MM-DD");
      state.end_date = dayjs(action.payload.end_date).format("YYYY-MM-DD");
      state.no_of_records = action.payload.no_of_records;
      state.seller_id = action.payload.seller_id;
    },
    changeLookupPayments: (
      state: PaymentsState,
      action: PayloadAction<boolean>
    ) => {
      state.lookup = action.payload;
    },
    changePaymentsSeller: (
      state: PaymentsState,
      action: PayloadAction<string>
    ) => {
      state.seller_id = action.payload;
    },
    changePaymentsPnlMode: (
      state: PaymentsState,
      action: PayloadAction<number>
    ) => {
      state.view = action.payload;
    },
  },
});

export const {
  changePaymentsState,
  changeLookupPayments,
  changePaymentsSeller,
  changePaymentsPnlMode,
} = paymentsSlice.actions;
